import { Injectable } from "@angular/core";
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from "@angular/common/http";
import { Observable } from "rxjs";
import { TenantContextService } from "src/app/services/tenant-context.service";

/**
 * Ajoute le header {@code X-Impersonate-Tenant} sur toutes les requêtes
 * lorsque le super-admin a démarré une impersonation.
 *
 * Sans impersonation active : l'interceptor n'ajoute rien — c'est le backend
 * qui résout le tenant via le JWT (SecurityService.getEffectiveTenantId()).
 *
 * Le header doit matcher la constante backend
 * {@code SecurityService.IMPERSONATE_HEADER}.
 */
@Injectable()
export class ImpersonationInterceptor implements HttpInterceptor {
  static readonly HEADER_NAME = "X-Impersonate-Tenant";

  constructor(private tenantContext: TenantContextService) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const target = this.tenantContext.impersonatingTenantIdSnapshot;
    if (target) {
      req = req.clone({
        setHeaders: { [ImpersonationInterceptor.HEADER_NAME]: target },
      });
    }
    return next.handle(req);
  }
}
